import api from './api';

const fiscalService = {
  getCatalogs: async (params = {}) => {
    const response = await api.get('/fiscal/catalogs', { params });
    return response.data;
  },

  getReadiness: async () => {
    const response = await api.get('/fiscal/readiness');
    return response.data;
  },

  getCompanyProfile: async () => {
    const response = await api.get('/fiscal/company-profile');
    return response.data;
  },

  saveCompanyProfile: async (payload) => {
    const response = await api.put('/fiscal/company-profile', payload);
    return response.data;
  },

  getCertificates: async (params = {}) => {
    const response = await api.get('/fiscal/certificates', { params });
    return response.data;
  },

  uploadCertificate: async (formData) => {
    const response = await api.post('/fiscal/certificates', formData);
    return response.data;
  },

  validateCertificate: async (certificateId) => {
    const response = await api.post(`/fiscal/certificates/${certificateId}/validate`);
    return response.data;
  },

  deactivateCertificate: async (certificateId) => {
    const response = await api.delete(`/fiscal/certificates/${certificateId}`);
    return response.data;
  },

  getClientProfiles: async (params = {}) => {
    const response = await api.get('/fiscal/client-profiles', { params });
    return response.data;
  },

  getClientProfile: async (clientId) => {
    const response = await api.get(`/fiscal/client-profiles/${clientId}`);
    return response.data;
  },

  saveClientProfile: async (clientId, payload) => {
    const response = await api.put(`/fiscal/client-profiles/${clientId}`, payload);
    return response.data;
  },

  getProductMappings: async (params = {}) => {
    const response = await api.get('/fiscal/product-mappings', { params });
    return response.data;
  },

  createProductMapping: async (payload) => {
    const response = await api.post('/fiscal/product-mappings', payload);
    return response.data;
  },

  updateProductMapping: async (mappingId, payload) => {
    const response = await api.put(`/fiscal/product-mappings/${mappingId}`, payload);
    return response.data;
  },

  deleteProductMapping: async (mappingId) => {
    const response = await api.delete(`/fiscal/product-mappings/${mappingId}`);
    return response.data;
  },

  getTaxDocuments: async (params = {}) => {
    const response = await api.get('/fiscal/tax-documents', { params });
    return response.data;
  },

  uploadTaxDocument: async (formData) => {
    const response = await api.post('/fiscal/tax-documents', formData);
    return response.data;
  },

  getTaxDocument: async (documentId) => {
    const response = await api.get(`/fiscal/tax-documents/${documentId}`);
    return response.data;
  },

  reviewTaxDocument: async (documentId, payload) => {
    const response = await api.put(`/fiscal/tax-documents/${documentId}/review`, payload);
    return response.data;
  },

  verifyTaxDocument: async (documentId, payload) => {
    const response = await api.put(`/fiscal/tax-documents/${documentId}/verify`, payload);
    return response.data;
  },

  rejectTaxDocument: async (documentId, payload) => {
    const response = await api.put(`/fiscal/tax-documents/${documentId}/reject`, payload);
    return response.data;
  },

  getSourceInvoices: async (params = {}) => {
    const response = await api.get('/fiscal/source-invoices', { params });
    return response.data;
  },

  getFiscalDocuments: async (params = {}) => {
    const response = await api.get('/fiscal/documents', { params });
    return response.data;
  },

  getFiscalDocument: async (documentId) => {
    const response = await api.get(`/fiscal/documents/${documentId}`);
    return response.data;
  },

  createFiscalDraft: async (invoiceId, payload = {}) => {
    const response = await api.post(`/fiscal/documents/from-invoice/${invoiceId}`, payload);
    return response.data;
  },

  updateFiscalDocument: async (documentId, payload) => {
    const response = await api.put(`/fiscal/documents/${documentId}`, payload);
    return response.data;
  },

  validateFiscalDocument: async (documentId) => {
    const response = await api.post(`/fiscal/documents/${documentId}/validate`);
    return response.data;
  },

  approveFiscalDocument: async (documentId) => {
    const response = await api.post(`/fiscal/documents/${documentId}/approve`);
    return response.data;
  },

  reopenFiscalDocument: async (documentId) => {
    const response = await api.post(`/fiscal/documents/${documentId}/reopen`);
    return response.data;
  }
};

export default fiscalService;
